export const BAR_COLOR = '#1a4480';
export const BAR_COLOR_CREATIVE_LAB = '#5A878A'